<template>
    <div>
        <b-row v-if="product" class="mt-3">
            <b-col>
                <div class="table-responsive" >
                    <h5 class="border rounded bg-light m-0 mb-3 p-2 text-center font-weight-bold">
                        <i class="fa fa-product-hunt"/> PRODUCTO
                    </h5>

                    <table class="table table-striped table-hover mb-4">
                        <tbody>
                            <tr>
                                <td class="font-weight-bold">
                                    Nombre
                                </td>
                                <td colspan="3">{{ product.nombre }}</td>
                            </tr>
                            <tr >
                                <td class="font-weight-bold">
                                    Sinónimos
                                </td>
                                <td colspan="3">
                                    {{ product.sinonimos }}
                                </td>
                            </tr>
                            <tr >
                                <td class="font-weight-bold">
                                    Componentes
                                </td>
                                <td colspan="3"  v-if="product && product.components && product.components.length">
                                    <span v-for="(components, index) of product.components || []" :key="components.id">
                                        {{ components.name }}<span v-if="index < product.components.length - 1">;</span>
                                    </span>
                                </td>
                            </tr>
                            <tr >
                                <td class="font-weight-bold">
                                    CAS
                                </td>
                                <td>{{ product.cas }}</td>
                                <td class="font-weight-bold">
                                    Uso
                                </td>
                                <td v-html="product.uso"/>
                            </tr>
                            <tr>
                                <td  class="font-weight-bold">
                                    Estado
                                </td>
                                <td >
                                    {{ convertEstadoProduct(product.estado) }}
                                </td>
                                <td class="font-weight-bold">
                                    Fabricante
                                </td>
                                <td>
                                    {{ getStringData(product.fabricante,'nombre') }}
                                </td>
                            </tr>
                            <tr >
                                <td class="font-weight-bold">
                                    Observación
                                </td>
                                <td colspan="3">{{ product.observacion }}</td>
                            </tr>
                            <tr >
                                <td class="font-weight-bold">
                                    Fecha FDS
                                </td>
                                <td colspan="3">{{ getDateFDS(product) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>

export default {
    name: "productDetail",
    props: ['product'],
    methods:{
        getStringData(data, key, response = ''){
            if(data === undefined) return response;
            else return data[key]
        },
        convertEstadoProduct(estado) {
            var text = '';
            switch (estado) {
                case 131:
                    text = 'Solido';
                    break;

                case 132:
                    text = 'Liquido';
                    break;

                case 133:
                    text = 'Gaseoso';
                    break;

                default:
                    break;
            }

            return text;
        },
        getDateFDS(product) {
            if(product.attachments.length > 0){
                const fds = product.attachments[0];
                return fds.fecha;
            }
            return 'No registra';
        }
    }
}
</script>
